var _rect, _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgVoz = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#395ABF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5569 11.0988C12.299 10.5263 12.028 10.5132 11.7834 10.5066C11.585 10.5 11.3536 10.5 11.1222 10.5C10.8908 10.5 10.5206 10.5855 10.2033 10.9277C9.88591 11.2698 9 12.0989 9 13.7899C9 15.4744 10.2363 17.1062 10.4082 17.3365C10.5801 17.5668 12.7949 21.1397 16.2923 22.5149C19.2012 23.6598 19.7962 23.4295 20.4243 23.3702C21.0524 23.311 22.4606 22.5412 22.7515 21.7384C23.0358 20.9357 23.0358 20.2514 22.9498 20.1066C22.8639 19.9619 22.6325 19.8763 22.2887 19.7052C21.9449 19.5342 20.2524 18.7051 19.9351 18.5867C19.6177 18.4748 19.3863 18.4156 19.1616 18.7577C18.9302 19.0999 18.269 19.8697 18.0707 20.1C17.8724 20.3303 17.6674 20.3567 17.3236 20.1856C16.9798 20.0145 15.8691 19.6526 14.5535 18.4814C13.5287 17.5734 12.8346 16.4482 12.6362 16.1061C12.4379 15.7639 12.6164 15.5797 12.7883 15.4086C12.9403 15.2573 13.1321 15.0072 13.304 14.8098C13.4758 14.6124 13.5353 14.4677 13.6477 14.2374C13.7601 14.0071 13.7072 13.8097 13.6213 13.6386C13.5353 13.4741 12.861 11.7765 12.5569 11.0988Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVoz, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/voz.dcd42ba2.svg";
export { ForwardRef as ReactComponent };